export const availablePartners = {
    data() {
        return {
            partners: ["smarten", "eugesta", "odoo", "old_balsnack"]
        };
    }
};
